import { json, type LoaderFunctionArgs } from '@remix-run/node';
import { getConversations } from '~/modules/chat/api/get-conversations.server';

export const CONVERSATIONS_API = '/remix-api/chat/conversations';

/**
 * API endpoint to get the user's conversations. Use with the
 * `useConversations` hook.
 * @see {@link packages/web/app/modules/chat/hook/useConversations.ts}
 */
export const loader = async ({ context }: LoaderFunctionArgs) => {
    const { logger } = context;
    try {
        const conversations = await getConversations({ context });

        if (!conversations) {
            return json(null, { status: 500 });
        }

        return json({
            conversations: conversations.nodes,
            pageInfo: conversations.pageInfo,
        });
    } catch (error) {
        logger.error(`Error in ${CONVERSATIONS_API}`, { error });
        return json(null, { status: 500 });
    }
};
